<script setup lang="ts">
import { onMounted, watch } from 'vue';
import { useFoldersStore } from '@/stores/folders';
import { useSettingsStore } from '@/stores/settings';
import { useAuth } from '@/composables/useAuth';
import { useWorkspaceApi } from '@/composables/useWorkspaceApi';
import { useWordDocument } from '@/composables/useWordDocument';
import FolderList from './FolderList.vue';
import PieceList from './PieceList.vue';

const { organizationId } = useAuth();
const foldersStore = useFoldersStore();
const settingsStore = useSettingsStore();
const { fetchFolders } = useWorkspaceApi();
const { getDocumentFolderId, setDocumentFolderId } = useWordDocument();

// Quand un dossier est sélectionné, sauvegarder dans le document
watch(
	() => foldersStore.selectedFolder,
	async (folder) => {
		if (folder) {
			await setDocumentFolderId(folder.id).catch(() => {});
		}
	}
);

// Après authentification, tenter de rouvrir le dossier sauvegardé dans le document
const tryAutoSelectFolder = async () => {
	if (foldersStore.selectedFolder) return;
	const savedFolderId = await getDocumentFolderId().catch(() => null);
	if (!savedFolderId || !organizationId.value) return;

	const folders = await fetchFolders(organizationId.value).catch(() => []);
	foldersStore.setFolders(folders);
	const folder = folders.find((f) => f.id === savedFolderId);
	if (folder) foldersStore.selectFolder(folder);
};

onMounted(async () => {
	settingsStore.loadConvention();
	await tryAutoSelectFolder();
});
</script>

<template>
	<div class="flex flex-col h-full">
		<PieceList v-if="foldersStore.selectedFolder" />
		<FolderList v-else />
	</div>
</template>
